import React from 'react';
import styled from '@emotion/styled/macro';
import CheckboxInput from './checkbox-input';

const CheckboxInputHeader = ({
  id,
  label,
  selectedCheckboxes,
  handleChange,
  isBold = true,
  dataGroupId,
  className,
}) => {
  return (
    <CheckboxInput
      id={id}
      label={label}
      selectedCheckboxes={selectedCheckboxes}
      handleChange={handleChange}
      isBold={isBold}
      dataGroupId={dataGroupId}
    />
  );
};

// === CheckboxInputHeader CSS ===
const StyledCheckboxInputHeader = styled(CheckboxInputHeader)``;

export default StyledCheckboxInputHeader;
